import React, { Component } from "react";
import { MDBIcon } from "mdb-react-ui-kit";

import "./ActorsSection.css";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import { mfmFramedUrl } from "Projects/CC_cubi_clan_project/Utils/MfmService";
import { MfmPhoto } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmPhoto/MfmPhoto";

import profile_default_img from "images/profile_default.png";

const ACTOR_FORMAT_KEY = "ratio:3:4";

/**
 * ActorsSection
 *
 * Muestra una lista vertical de actores publicados. Cada fila ocupa el ancho
 * completo y alterna la disposición foto / información (izquierda-derecha,
 * derecha-izquierda). La foto se muestra en formato carnet (retrato 3:4).
 */
class ActorsSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actors: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.loadActors();
  }

  transformActor(actor) {
    if (!actor) return {};
    const id = actor.idActor || null;
    const slug = actor.slug || null;
    const name = actor.name || actor.nombre || "Miembro";
    const bio = actor.bio || actor.biography || actor.description || "";
    const nationality = actor.nationality || "";
    const website = actor.website || "";
    const status = (actor.status || actor.estado || "draft").toLowerCase();
    const sortOrder =
      Number.isFinite(Number(actor.sortOrder)) ? Number(actor.sortOrder) : 0;

    let image = null;
    if (actor.imageUuid) {
      image = mfmFramedUrl(actor.imageUuid, 216, 288, ACTOR_FORMAT_KEY);
    } else {
      image = profile_default_img;
    }
    const actorRole = actor.actorRole || null;
    return { id, slug, name, bio, nationality, website, image, imageUuid: actor.imageUuid || null, status, sortOrder, actorRole };
  }

  loadActors() {
    this.setState({ loading: true });
    this.props.onLoading && this.props.onLoading(true);
    doFetch("MUGIN", "getActors", { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        const rows = data && data.DATA ? data.DATA : [];
        const actors = (rows || [])
          .filter((a) => a != null && a.status === "published")
          .map((a) => this.transformActor(a))
          .sort((x, y) => {
            const sx = Number(x.sortOrder);
            const sy = Number(y.sortOrder);
            if (Number.isFinite(sx) && Number.isFinite(sy)) return sx - sy;
            return 0;
          });
        this.setState({ actors });
      })
      .catch((error) => {
        console.error("Error al obtener actores:", error);
        toast.show({
          message: "Ha ocurrido un error al cargar los miembros",
          type: "danger",
          position: "bottom-center",
          size: "wide",
          animation: "slide",
          timeout: 5000,
        });
      })
      .finally(() => {
        this.setState({ loading: false });
        this.props.onLoading && this.props.onLoading(false);
      });
  }

  openActor = (slug) => {
    if (!slug) return;
    const href = `/actor/${slug}`;
    if (this.props.onHandleNavLinks) {
      this.props.onHandleNavLinks(null, href);
    } else {
      window.location.href = href;
    }
  };

  renderActorRow(actor, index) {
    const reversed = index % 2 !== 0;

    const imgBlock = (
      <div className="actor-row-img-wrapper">
        <MfmPhoto
          uuid={actor.imageUuid}
          width={216}
          height={288}
          formatKey={ACTOR_FORMAT_KEY}
          className="actor-row-img"
          fallback={profile_default_img}
          alt={actor.name}
        />
      </div>
    );

    const infoBlock = (
      <div className="actor-row-info">
        <h3 className="actor-row-name">{actor.name}</h3>
        {actor.actorRole && (
          <p className="actor-row-role">{actor.actorRole}</p>
        )}
        {actor.nationality && (
          <p className="actor-row-meta">
            <MDBIcon fas icon="globe-europe" className="me-1" />
            {actor.nationality}
          </p>
        )}
        {actor.bio && (
          <div
            className="actor-row-bio"
            dangerouslySetInnerHTML={{ __html: actor.bio }}
          />
        )}
        {actor.website && (
          <a
            className="actor-row-website"
            href={actor.website}
            target="_blank"
            rel="noopener noreferrer"
          >
            <MDBIcon fas icon="link" className="me-1" />
            {actor.website}
          </a>
        )}
        <span
          className="actor-row-link"
          onClick={() => this.openActor(actor.slug)}
        >
          Ver más <MDBIcon fas icon="chevron-right" size="sm" />
        </span>
      </div>
    );

    return (
      <div
        key={actor.id}
        className={`actor-row${reversed ? " actor-row--reverse" : ""}`}
      >
        {imgBlock}
        {infoBlock}
      </div>
    );
  }

  render() {
    const { actors, loading } = this.state;
    return (
      <section className="actors-section my-5">
        <h2 className="section-title mb-4">Quiénes somos</h2>
        {loading && <p>Cargando miembros...</p>}
        {!loading && actors.length === 0 && (
          <p>No hay miembros disponibles en este momento.</p>
        )}
        <div className="actors-list">
          {actors.map((actor, idx) => this.renderActorRow(actor, idx))}
        </div>
      </section>
    );
  }
}

export default ActorsSection;